<template>
  <div>
    <div>
      <ElXlsx @upData="upData" />
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="productName" label="产品">
      </el-table-column>
      <el-table-column prop="demo1" label="1月">
      </el-table-column>
      <el-table-column prop="demo2" label="2月">
      </el-table-column>
      <el-table-column prop="demo3" label="3月">
      </el-table-column>
      <el-table-column prop="demo4" label="4月">
      </el-table-column>
      <el-table-column prop="demo5" label="5月">
      </el-table-column>
      <el-table-column prop="demo6" label="6月">
      </el-table-column>
      <el-table-column prop="demo7" label="7月">
      </el-table-column>
      <el-table-column prop="demo8" label="8月">
      </el-table-column>
      <el-table-column prop="demo9" label="9月">
      </el-table-column>
      <el-table-column prop="demo10" label="10月">
      </el-table-column>
      <el-table-column prop="demo11" label="11月">
      </el-table-column>
      <el-table-column prop="demo12" label="12月">
      </el-table-column>
      <el-table-column prop="q1th" label="第一季度">
      </el-table-column>
      <el-table-column prop="q2th" label="第二季度">
      </el-table-column>
      <el-table-column prop="q3th" label="第三季度">
      </el-table-column>
      <el-table-column prop="q4th" label="第四季度">
      </el-table-column>
      <el-table-column prop="sum" label="年度">
      </el-table-column>
      <el-table-column prop="profit" label="毛利率">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import ElXlsx from '../../components/ElXlsx.vue'
  export default {
    components: {
      ElXlsx
    },
    inject: ['reload'],
    data() {
      return {
        tableData: [],
        items: ['productName', 'demo1', 'demo2', 'demo3', 'demo4', 'demo5', 'demo6', 'demo7', 'demo8', 'demo9', 'demo10', 'demo11', 'demo12', 'q1th', 'q2th', 'q3th', 'q4th', 'sum', 'profit']
      }
    },
    mounted() {
      this.$axios.post('/product_goal/findList').then(res => {
        this.tableData = res.data.data
      })
    },
    methods: {
      upData(e) {
        let dataArr = this.$replaceString(e, this.items)
        this.$axios.post('/product_goal/save', dataArr).then(res => {
          this.$message({
            message: '导入成功。',
            type: 'success'
          })
          this.reload()
        })
      },
    }
  }
</script>

<style scoped>
  .el-table {
    margin-top: 20px;
  }
</style>